import {
  FeatureName,
  LabelQuestionConfig,
  LabelResponseState,
  useIsFeatureEnabled,
} from '@gripp/shared-logic';
import { CommonLabel } from '../../../components/commonLabel';
import {
  RoutineQuestionExecutionForm,
  RoutineQuestionExecutionFormProps,
} from '../types';

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const LabelQuestionExecutionFormOld: RoutineQuestionExecutionForm<
  LabelQuestionConfig,
  LabelResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    LabelQuestionConfig,
    LabelResponseState
  >
) => {
  const fieldPrefix = `responses.${props.responseIndex}`;
  const fieldName = `${fieldPrefix}.labels`;

  return (
    <>
      {props?.workspaceAsset?.id && (
        <CommonLabel
          workspaceId={props.workspaceAsset.workspace.id}
          fieldName={fieldName}
        />
      )}
    </>
  );
};

// TODO: Crop Circle Redesign | Remove to LabelQuestionExecutionFormBase after feature is fully rolled out
const LabelQuestionExecutionFormBase: RoutineQuestionExecutionForm<
  LabelQuestionConfig,
  LabelResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    LabelQuestionConfig,
    LabelResponseState
  >
) => {
  const fieldPrefix = `responses.${props.responseIndex}`;
  const fieldName = `${fieldPrefix}.labels`;

  return (
    <>
      {props?.workspaceAsset?.id && (
        <CommonLabel
          workspaceId={props.workspaceAsset.workspace.id}
          fieldName={fieldName}
        />
      )}
    </>
  );
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
export const LabelQuestionExecutionForm: RoutineQuestionExecutionForm<
  LabelQuestionConfig,
  LabelResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    LabelQuestionConfig,
    LabelResponseState
  >
) => {
  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  if (!isCropCircleRedesignEnabled) {
    return <LabelQuestionExecutionFormOld {...props} />;
  }

  // TODO: Crop Circle Redesign | Remove to LabelQuestionExecutionFormBase after feature is fully rolled out
  return <LabelQuestionExecutionFormBase {...props} />;
};
